import { SafeBaseObject } from "@app/core/models/base-object.models";

export interface IRescomApiInvokeAIParams {
    Context: string;
    ServiceTypeID?: number;
    Field: string;
    Mode: 'interactive' | 'batch';
    Text: string;
    User?: string;
    Language?: string;
    MainTitle?: string;
}

export class RescomApiInvokeAI extends SafeBaseObject {
    result?: RescomApiInvokeAIResult
    sessionID = 0

    constructor(data: any) {
        super();
        if (data) this.updateData(data);
        if (data.result) this.result = new RescomApiInvokeAIResult(data.result);
    }
}

export class RescomApiInvokeAIResult extends SafeBaseObject {
    description = ''
    description_language = ''
    title = ''
    title_language = ''
    main_title = ''
    main_title_language = ''
    error = ''

    constructor(data: any) {
        super();
        if (data) this.updateData(data);
    }

}


